module.exports = __webpack_public_path__ + "img/MDG.674403ff.svg";